export default "__VITE_PUBLIC_ASSET__a804e434__"